var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccessBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 0C33.5789 0 0 33.5789 0 75C0 116.423 33.5789 150 75 150C116.423 150 150 116.423 150 75C150 33.5789 116.423 0 75 0ZM75 140.773C38.8148 140.773 9.375 111.185 9.375 74.9997C9.375 38.8145 38.8148 9.37471 75 9.37471C111.185 9.37471 140.625 38.8147 140.625 74.9997C140.625 111.185 111.185 140.773 75 140.773ZM104.932 47.557L60.928 91.8375L41.1116 72.0211C39.2811 70.1906 36.3139 70.1906 34.4811 72.0211C32.6506 73.8516 32.6506 76.8187 34.4811 78.6492L57.6819 101.852C59.5124 103.68 62.4795 103.68 64.3124 101.852C64.5233 101.641 64.7039 101.412 64.868 101.173L111.565 54.1874C113.393 52.3569 113.393 49.3897 111.565 47.557C109.732 45.7266 106.765 45.7266 104.932 47.557Z",
    fill: "#007696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessBlue);
export default __webpack_public_path__ + "static/media/icon-success-blue.a488544d7189679a1e2f9320b23534b0.svg";
export { ForwardRef as ReactComponent };